import { IonContent } from '@ionic/angular';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import {
  AlertController,
  LoadingController,
  ModalController,
  Platform,
} from '@ionic/angular';
import { List } from 'immutable';
import { Booking, Client } from 'src/app/models';
import { ClientService } from 'src/app/services';
import { BookingPhotoEditorComponent } from '../booking-photo-editor/booking-photo-editor.component';
import { Utilities } from '../../utilities/utilities';
import { ActivatedRoute } from '@angular/router';
export interface PhotoModel {
  id: number;
  raw: boolean;
  name: string;
  note: string;
  date: Date;
}

@Component({
  selector: 'smr-booking-photos-manager',
  templateUrl: './booking-photos-manager.component.html',
  styleUrls: ['./booking-photos-manager.component.scss'],
})
export class BookingPhotosManagerComponent implements OnInit, OnChanges {
  @Input() client: Client;
  @Input() booking: Booking;
  @Input() isReadOnly: boolean = false;
  @Input() content: IonContent;

  public clientSubmittedPhotos: List<PhotoModel> = List([]);

  public pastBookings: List<Booking> = List([]);

  public isLoadingPastBookings: boolean;

  public errorOccurredWhileLoadingPastBookings: boolean;

  public selectedBooking: Booking;

  public clientPhotos;

  public bookingPhotos;

  @Output() profilePhoto = new EventEmitter<string>();

  constructor(
    public modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private clientService: ClientService,
    public platform: Platform,
    public route: ActivatedRoute
  ) {}

  public ngOnInit() {
    this.clientPhotos = []
    this.loadClientPhotos();
  }

  public loadClientPhotos() {
    this.clientService.loadClientPhotos(this.client.id).subscribe(data =>{
      this.clientPhotos = data
      this.clientPhotos.sort((a,b) => {return new Date(b.date).getTime() - new Date(a.date).getTime()});
    })    
  }

  public ngOnChanges (changes: SimpleChanges) {
    if(changes.client){
      this.loadClientPhotos();
    }
  }

  compareDate(date1, date2) {
    if (
      date1.getYear() == date2.getYear() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate()
    )
      return true;
    return false;
  }

  public async onTakePhoto(base64Image: string) {
    const photo = base64Image;

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.clientService.insertClientPhoto(this.client.id, photo).subscribe({
      next: async () => {
        this.clientPhotos = await this.clientService.loadClientPhotos(this.client.id).toPromise();
        this.clientPhotos.sort((a,b) => {return new Date(b.date).getTime() - new Date(a.date).getTime()});
        loader.dismiss();
      },
      error: async (err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  public async onViewPhoto(photo: PhotoModel) {
    const modal = await this.modalCtrl.create({
      component: BookingPhotoEditorComponent,
      componentProps: {
        photo: photo,
      },
    });
    modal.present();
  }

  public async onImportPhoto() {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: CameraSource.Photos
    });
    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    var imageUrl = image.base64String;

    // Can be set to the src of an image now
    const base64Image = 'data:image/jpeg;base64,' + imageUrl;
    this.onTakePhoto(base64Image);
  }

  public async onCapturePhoto() {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: CameraSource.Camera
    });
    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    var imageUrl = image.base64String;

    // Can be set to the src of an image now
    const base64Image = 'data:image/jpeg;base64,' + imageUrl;
    this.onTakePhoto(base64Image);
  }

  public async onImageSelect(event) {
    const avaiableFileTyoes = ['image/gif', 'image/png', 'image/jpeg'];
    const file = event.target.files[0];
    if (!avaiableFileTyoes.includes(file.type)) {
      const alert = await this.alertCtrl.create({
        header: 'Sorry, we were unable to use that image.',
        message:
          'Please use a .jpg, .gif or .png file and contact our support if you continue to enouter issues.',
        buttons: [
          {
            text: 'OK',
            role: 'dismiss',
          },
        ],
      });
      alert.present();
      return;
    }
    var reader = new FileReader();
    reader.onload = this.selectBooking.bind(this);

    reader.readAsBinaryString(file);
  }

  async selectBooking(readerEvt) {
    this.imageUpload(readerEvt);
  }

  async imageUpload(readerEvt) {
    var base64textString = btoa(readerEvt.target.result);
    const photo = 'data:image/jpeg;base64,' + base64textString;

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.clientService.insertClientPhoto(this.client.id, photo).subscribe({
      next: (res) => {
        this.clientService.loadClientPhotos(this.client.id).subscribe(data =>{
          this.clientPhotos = data
          this.clientPhotos.sort((a,b) => {return new Date(b.date).getTime() - new Date(a.date).getTime()});
        })
        loader.dismiss();
      },
      error: async (err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  setProfilePhoto(profilePhoto: string) {
    this.profilePhoto.emit(profilePhoto);
  }
}
